module.exports = __webpack_public_path__ + "img/nyx.56e00b80.svg";